export default defineNuxtPlugin(() => {
  window.addEventListener('error', (e) => {
    if (e.message.includes('Failed to fetch dynamically imported module')) {
      alert('A new version is available. Please refresh the page.')
    }
  })

  window.addEventListener('unhandledrejection', (e) => {
    if (
      e.reason.message?.includes('Failed to fetch dynamically imported module')
    ) {
      alert('A new version is available. Please refresh the page.')
    }
  })
})
